import React, {Component} from 'react';
import {Typography, Modal, Button, MenuItem, TextField} from '@material-ui/core'
import {FormControl, Select, OutlinedInput, InputLabel} from '@material-ui/core'

import { withStyles } from '@material-ui/core/styles';

// Error Popup
import ErrorPopup from '../components/ErrorPopup.js'

import '../stylesheets/App.css'



class AddToCartModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      none: undefined
    }
  }

  render() {
    var modalHelmetLabelWidth = 85;
    var modalPedalsLabelWidth = 50;

    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.props.open}
          onClose={this.props.handleClose.bind(this)}
        >
          <div className="modal-css">
            <ErrorPopup hideDuration={6000} errorOpen={this.props.modalError} vertical='top' horizontal='center' handleErrorClose={this.props.handleModalErrorClose.bind(this)} errorMessage={this.props.errorMessage} />
            <Typography variant="h5" style={{textAlign: 'center', marginBottom: 15}}>Rider Profile</Typography>
            <div style={{flexDirection: 'row', display: 'flex', flex: 1}}>
              <TextField
                style={{flex: 0.5, margin: 5}}
                id="outlined-number"
                label="Rider Height (cm)"
                value={this.props.riderHeight}
                name="riderHeight"
                onChange={this.props.handleModalChange}
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
              />

              <FormControl style={{flex: 0.5, margin: 5}} className="material-form" variant="outlined">
                <InputLabel
                  htmlFor="outlined-helmet-simple"
                >
                  Helmet Size
                </InputLabel>
                <Select
                  value={this.props.helmet}
                  name="helmet"
                  onChange={this.props.handleModalChange}
                  input={
                    <OutlinedInput
                      labelWidth={modalHelmetLabelWidth}
                      name="helmet"
                      id="outlined-helmet-simple"
                    />
                  }
                >
                  <MenuItem value="small">Small</MenuItem>
                  <MenuItem value="medium">Medium</MenuItem>
                  <MenuItem value="large">Large</MenuItem>
                  <MenuItem value="byo">Bringing your own</MenuItem>
                </Select>
              </FormControl>


            </div>

            <div style={{flexDirection: 'row', display: 'flex', flex: 1, marginTop: 5}}>
              <FormControl style={{flex: 1, margin: 5}} className="material-form" variant="outlined">
                <InputLabel
                  htmlFor="outlined-bikePedals-simple"
                >
                  Pedals
                </InputLabel>
                <Select
                  value={this.props.bikePedals}
                  name="bikePedals"
                  onChange={this.props.handleModalChange}
                  input={
                    <OutlinedInput
                      labelWidth={modalPedalsLabelWidth}
                      name="bikePedals"
                      id="outlined-bikePedals-simple"
                    />
                  }
                >
                  <MenuItem value="small">Small</MenuItem>
                  <MenuItem value="medium">Medium</MenuItem>
                  <MenuItem value="large">Large</MenuItem>
                  <MenuItem value="byo">Bringing your own</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div style={{flexDirection: 'row', display: 'flex', flex: 1, marginTop: 20, alignItems: 'center'}}>
              <div style={{flex:0.45}} className="optionalBorder"></div>
              <Typography style={{flex: 0.1, textAlign: 'center'}} variant="subtitle2">OPTIONAL</Typography>
              <div style={{flex:0.45}} className="optionalBorder"></div>
            </div>

            <div style={{flexDirection: 'row', display: 'flex', flex: 1, marginTop: 10}}>
              <TextField
                style={{flex: 0.5, margin: 5}}
                id="outlined-number"
                label="Bar Reach (mm)"
                value={this.props.barReach}
                name="barReach"
                onChange={this.props.handleModalChange}
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
              />

              <TextField
                style={{flex: 0.5, margin: 5}}
                id="outlined-number"
                label="Bar Drop (mm)"
                value={this.props.barDrop}
                name="barDrop"
                onChange={this.props.handleModalChange}
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
              />
            </div>

            <div style={{flexDirection: 'row', display: 'flex', flex: 1, marginTop: 5}}>
              <TextField
                style={{flex: 1, margin: 5}}
                id="outlined-number"
                label="Seat Height (mm)"
                value={this.props.seatHeight}
                name="seatHeight"
                onChange={this.props.handleModalChange}
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
              />
            </div>

            <div style={{flexDirection: 'row', display: 'flex', flex: 1, marginTop: 20, justifyContent: 'center'}}>
              <Button onClick={this.props.handleSubmit} style={{backgroundColor: "#45b97c", color: "white", flex: 0.4}} size="large" className="material-form">DONE</Button>
            </div>

          </div>
        </Modal>
      </div>
    )
  }
}

const paperStyle = {
  position: 'absolute',
  outline: 'none',
  padding: 5,
  width: 80,
  backgroundColor: 'white'

}

const ModalWrapped = AddToCartModal;

export default AddToCartModal;